var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full",attrs:{"id":"profiles"}},[_c('div',{staticClass:"btn-pills-group"},[_c('button',{staticClass:"btn btn-pill",class:{
				off: !_vm.profiles.profile_1,
				active: _vm.selectedProfile === 'profile_1',
			},attrs:{"id":"profile_1"},on:{"click":function($event){return _vm.SelectProfile('profile_1')}}},[_vm._v(" F1 ")]),_c('button',{staticClass:"btn btn-pill",class:{
				off: !_vm.profiles.profile_2,
				active: _vm.selectedProfile === 'profile_2',
			},attrs:{"id":"profile_2"},on:{"click":function($event){return _vm.SelectProfile('profile_2')}}},[_vm._v(" F2 ")]),_c('button',{staticClass:"btn btn-pill",class:{
				off: !_vm.profiles.profile_3,
				active: _vm.selectedProfile === 'profile_3',
			},attrs:{"id":"profile_3"},on:{"click":function($event){return _vm.SelectProfile('profile_3')}}},[_vm._v(" F3 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }